import { OptimizationGroup } from '@e2m-customer-portal/domains';
import { Button } from '@mui/material';
import { MarketLocation } from 'generated/graphql';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface OptimizationPageProps {
  optimizationGroupId: string;
  marketLocations: Array<MarketLocation>;
}

export function OptimizationPage({
  optimizationGroupId,
  marketLocations,
}: Readonly<OptimizationPageProps>): ReactElement<OptimizationPageProps> {
  const [t] = useTranslation();

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between gap-2 flex-wrap px-14 py-5">
        <div className="md:basis-1/2">
          <h1 className="mt-0 mb-2 font-bold text-lg leading-5">{t('OPTIMIZATION_TITLE')}</h1>
          <p className="m-0 text-sm leading-6">{t('LOREM_IPSUM')}</p>
        </div>
        <Button disabled>{t('OPTIMIZATION_CREATE_NEW_GROUP')}</Button>
      </div>
      <div className="flex flex-col gap-y-1 px-0.5 py-1 bg-grey-50">
        <OptimizationGroup optimizationGroupId={optimizationGroupId} marketLocations={marketLocations} startExpanded />
      </div>
    </div>
  );
}
